import { RestRequest, RestContext, ResponseFunction } from 'msw'
import {
  addToEntityListData,
  updateEntityListData,
  deleteEntityListData,
} from '../../modules/mockDataCommon'
import { requireAuthenticatedUser } from '../../decorators'
import {
  getProductSubcategoryListData,
  getProductSubcategoryOverviewData,
} from './mockData'
import type {
  IProductSubcategory,
  IProductSubcategoryOverview,
} from '~/types/product/models'

export const apiEntityPath = '/api/productsubcategories'

interface GetProductSubcategoriesResponse {
  data: IProductSubcategory[]
}

async function getList(
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) {
  console.log(`Returning productSubcategory list`)
  const responseBody: GetProductSubcategoriesResponse = {
    data: await getProductSubcategoryListData(),
  }
  return res(ctx.status(200), ctx.json(responseBody))
}

interface GetProductSubcategoryOverviewResponse {
  data: IProductSubcategoryOverview
}

async function getOverviewById(
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) {
  const { id } = req.params
  if (typeof id !== 'string') {
    const responseBody = {
      statusCode: 500,
      message: 'Passed ID is not a string',
    }
    return res(ctx.status(500), ctx.json(responseBody))
  }
  const obj = await getProductSubcategoryOverviewData(id)
  if (obj) {
    console.log(`Returning overview for productSubcategory "${id}"`)
    const responseBody: GetProductSubcategoryOverviewResponse = {
      data: obj,
    }
    return res(ctx.status(200), ctx.json(responseBody))
  } else {
    const responseBody = { statusCode: 404, message: 'Resource not found.' }
    return res(ctx.status(404), ctx.json(responseBody))
  }
}

// post

const postProductSubcategory = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return addToEntityListData(req, res, ctx, getProductSubcategoryListData)
}

const patchProductSubcategory = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return updateEntityListData(req, res, ctx, getProductSubcategoryListData)
}

const deleteProductSubcategory = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return deleteEntityListData(req, res, ctx, getProductSubcategoryListData)
}

export const handlers = [
  {
    method: 'get',
    path: apiEntityPath,
    handler: getList,
  },
  {
    method: 'get',
    path: '/api/productsubcategories/:id/overview',
    handler: getOverviewById,
  },
  {
    method: 'post',
    path: apiEntityPath,
    handler: postProductSubcategory,
  },
  {
    method: 'patch',
    path: '/api/productsubcategories/:id',
    handler: patchProductSubcategory,
  },
  {
    method: 'delete',
    path: '/api/productsubcategories/:id',
    handler: deleteProductSubcategory,
  },
].map((h) => ({ ...h, ...{ handler: requireAuthenticatedUser(h.handler) } }))
